var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionTrust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 529,
    viewBox: "0 0 630 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_110_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.999 36.4669L203.664 148.003L314.999 259.539L426.335 148.003L314.999 36.4669Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.999 36.4669L203.664 148.003L314.999 259.539L426.335 148.003L314.999 36.4669Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.04 121.449C320.972 121.449 326.77 119.687 331.703 116.385C336.635 113.084 340.48 108.391 342.75 102.901C345.02 97.4102 345.614 91.369 344.456 85.5405C343.299 79.712 340.442 74.3582 336.248 70.1561C332.053 65.9539 326.709 63.0913 320.891 61.9319C315.073 60.7726 309.043 61.3684 303.562 63.6426C298.082 65.9168 293.397 69.7673 290.102 74.7084C286.806 79.6496 285.047 85.4595 285.047 91.4022C285.047 95.348 285.823 99.2551 287.33 102.901C288.837 106.546 291.046 109.858 293.832 112.648C296.617 115.438 299.923 117.652 303.562 119.162C307.201 120.672 311.101 121.449 315.04 121.449Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.489 331.337C111.422 331.337 117.223 329.573 122.156 326.27C127.089 322.967 130.933 318.272 133.202 312.779C135.471 307.287 136.063 301.243 134.902 295.413C133.742 289.584 130.881 284.231 126.683 280.03C122.484 275.829 117.136 272.97 111.316 271.816C105.495 270.661 99.4632 271.262 93.9834 273.542C88.5036 275.822 83.822 279.68 80.5312 284.626C77.2403 289.573 75.488 295.385 75.4959 301.33C75.5064 309.292 78.6709 316.924 84.2945 322.551C89.9181 328.177 97.5411 331.337 105.489 331.337Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524.551 331.337C530.485 331.337 536.285 329.573 541.218 326.27C546.152 322.967 549.996 318.272 552.265 312.779C554.534 307.287 555.125 301.243 553.965 295.413C552.804 289.584 549.944 284.231 545.745 280.03C541.547 275.829 536.199 272.97 530.378 271.816C524.557 270.661 518.526 271.262 513.046 273.542C507.566 275.822 502.885 279.68 499.594 284.626C496.303 289.573 494.55 295.385 494.558 301.33C494.569 309.292 497.733 316.924 503.357 322.551C508.981 328.177 516.604 331.337 524.551 331.337Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.999 128.433L142.433 301.31L314.999 474.187L487.565 301.31L314.999 128.433Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.027 215.382L229.293 301.27L315.027 387.158L400.761 301.27L315.027 215.382Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.284 301.29H123.087",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.999 169.007L182.934 301.31L314.999 433.613L447.064 301.31L314.999 169.007Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.5 14 12.5 14 12.5 14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.489 317.971C107.741 318.081 109.992 317.731 112.106 316.944C114.219 316.157 116.151 314.948 117.784 313.39C119.417 311.832 120.717 309.958 121.605 307.882C122.494 305.806 122.952 303.57 122.952 301.311C122.952 299.052 122.494 296.816 121.605 294.74C120.717 292.664 119.417 290.79 117.784 289.232C116.151 287.674 114.219 286.465 112.106 285.677C109.992 284.89 107.741 284.541 105.489 284.651",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.489 310.548C110.592 310.548 114.729 306.403 114.729 301.29C114.729 296.178 110.592 292.033 105.489 292.033C100.385 292.033 96.2477 296.178 96.2477 301.29C96.2477 306.403 100.385 310.548 105.489 310.548Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M400.756 301.29H507.902",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M524.551 284.651C520.282 284.86 516.256 286.707 513.308 289.808C510.36 292.91 508.716 297.028 508.716 301.311C508.716 305.593 510.36 309.712 513.308 312.813C516.256 315.914 520.282 317.761 524.551 317.97",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M524.551 310.548C529.655 310.548 533.792 306.403 533.792 301.29C533.792 296.178 529.655 292.033 524.551 292.033C519.448 292.033 515.31 296.178 515.31 301.29C515.31 306.403 519.448 310.548 524.551 310.548Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315 215.42V108.041",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M298.39 91.4017C298.599 95.6791 300.443 99.7121 303.538 102.665C306.634 105.619 310.745 107.265 315.02 107.265C319.295 107.265 323.405 105.619 326.501 102.665C329.597 99.7121 331.44 95.6791 331.649 91.4017",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.04 100.658C316.866 100.65 318.648 100.101 320.163 99.0791C321.677 98.0571 322.856 96.6086 323.549 94.9164C324.242 93.2241 324.419 91.3641 324.058 89.571C323.697 87.7779 322.814 86.132 321.52 84.8413C320.226 83.5506 318.58 82.6731 316.788 82.3191C314.997 81.9651 313.141 82.1502 311.455 82.852C309.768 83.5538 308.328 84.7411 307.314 86.2626C306.3 87.7842 305.759 89.5723 305.759 91.4015C305.759 92.6206 306 93.8276 306.466 94.9534C306.933 96.0792 307.618 97.1015 308.48 97.9617C309.342 98.8219 310.365 99.5027 311.491 99.9656C312.617 100.428 313.823 100.664 315.04 100.658Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M266.167 229.545L285.007 210.671L259.276 203.728L266.167 229.545Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.167 229.545L285.007 210.671L259.276 203.728L266.167 229.545Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M363.833 229.545L344.993 210.671L370.763 203.728L363.833 229.545Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M363.833 229.545L344.993 210.671L370.763 203.728L363.833 229.545Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M219.844 356.755L257.285 394.264L270.987 342.989L219.844 356.755Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.844 356.755L257.285 394.264L270.987 342.989L219.844 356.755Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M245.335 368.567L270.987 342.989",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M410.196 356.755L372.715 394.264L359.013 342.989L410.196 356.755Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M410.196 356.755L372.715 394.264L359.013 342.989L410.196 356.755Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M384.704 368.567L359.013 342.989",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M315 492.505C325.119 492.505 333.322 484.287 333.322 474.15C333.322 464.012 325.119 455.794 315 455.794C304.881 455.794 296.678 464.012 296.678 474.15C296.678 484.287 304.881 492.505 315 492.505Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M315 492.505C325.119 492.505 333.322 484.287 333.322 474.15C333.322 464.012 325.119 455.794 315 455.794C304.881 455.794 296.678 464.012 296.678 474.15C296.678 484.287 304.881 492.505 315 492.505Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M315 487.118C322.149 487.118 327.945 481.312 327.945 474.15C327.945 466.987 322.149 461.181 315 461.181C307.851 461.181 302.055 466.987 302.055 474.15C302.055 481.312 307.851 487.118 315 487.118Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M315 387.161V455.834",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.232 382.573L231.873 419.882L245.335 368.567L194.232 382.573Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M194.232 382.573L231.873 419.882L245.335 368.567L194.232 382.573Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.607 386.443L227.81 404.519L234.342 379.66L209.607 386.443Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M398.685 419.722L435.927 382.014L384.704 368.567L398.685 419.722Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M398.685 419.722L435.927 382.014L384.704 368.567L398.685 419.722Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M402.549 404.359L420.592 386.084L395.777 379.54L402.549 404.359Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M400.754 301.318L315.02 215.429L229.287 301.317L315.021 387.206L400.754 301.318Z",
    fill: "url(#paint0_linear_110_2647)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.98 315.383H297.704V310.731H293.386V280.748H318.526C325.332 280.748 330.088 284.46 332.769 289.619C334.26 292.564 335.146 295.766 335.378 299.043C335.653 302.387 335.301 305.753 334.341 308.974C332.478 315.051 328.257 320.028 321.775 321.136C319.271 321.436 316.744 321.524 314.224 321.397C312.871 321.35 311.469 321.35 310.797 321.35V326.026H314.151C316.967 326.173 319.79 326.067 322.585 325.71C331.133 324.262 336.569 317.955 338.919 310.287C340.068 306.524 340.502 302.587 340.199 298.671C339.916 294.777 338.859 290.974 337.088 287.474C333.628 280.796 327.487 276.048 318.575 276.048H288.598V315.383H290.98ZM317.337 286.818H300.323L300.298 291.526H300.323V310.707H300.298V315.368L300.323 315.368V321.389L288.858 321.326L288.875 325.987L302.721 326.034L305.111 326.01V315.381C310.234 315.391 315.102 315.382 316.186 315.328H316.429L316.448 315.327C319.762 315.176 328.971 314.756 328.971 301.33C328.939 287.609 317.377 286.818 317.337 286.818ZM305.111 310.707H315.943H316.194C318.301 310.612 324.207 310.343 324.191 301.369C324.191 292.61 317.912 291.621 317.069 291.526H305.111V310.707Z",
    fill: "#0A1214"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_110_2647",
    x: 203.164,
    y: 31.9665,
    width: 223.67,
    height: 228.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.882353 0 0 0 0 0.984314 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_110_2647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_2647",
    x1: 315.022,
    y1: 215.151,
    x2: 315.794,
    y2: 387.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionTrust);
export default __webpack_public_path__ + "static/media/missionTrust.ce29df44d467e8724033412522d4f86a.svg";
export { ForwardRef as ReactComponent };